import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { cloneElement } from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import { flattenChildren } from '../../utils/react-helpers.esm.js';
import { mapProps } from '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import { commonPropKeys } from '../types.esm.js';
import DescriptionDetail from './DescriptionDetail/index.esm.js';
export { default as DescriptionDetail } from './DescriptionDetail/index.esm.js';
import DescriptionTerm from './DescriptionTerm/index.esm.js';
export { default as DescriptionTerm } from './DescriptionTerm/index.esm.js';
import { useDescriptionListStyles, mapColumnWidth } from './styles.esm.js';

var DescriptionList = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var children = props.children,
      _props$columnSplit = props.columnSplit,
      columnSplit = _props$columnSplit === void 0 ? [1, 2] : _props$columnSplit,
      _props$layout = props.layout,
      layout = _props$layout === void 0 ? 'column' : _props$layout,
      rest = _objectWithoutPropertiesLoose(props, ["children", "columnSplit", "layout"]);

  if (!children) {
    throw new Error('`children` is required.');
  }

  var classNames = useDescriptionListStyles(layout, columnSplit);

  var renderChildren = function renderChildren() {
    var isColumnLayout = layout === 'column';
    var termCols = columnSplit[0],
        detailCols = columnSplit[1];
    var termWidth = isColumnLayout ? mapColumnWidth(termCols) : undefined;
    var detailWidth = isColumnLayout ? mapColumnWidth(detailCols) : undefined;

    var getDetailStart = function getDetailStart(key) {
      return isColumnLayout && key > 0 ? 'col-start-2' : undefined;
    };

    var validChildren = flattenChildren(children);
    var lastChild;
    var clones = validChildren.map(function (child, i) {
      var isTerm = child.type === DescriptionTerm;
      var lastIsDetail = lastChild && lastChild.type === DescriptionDetail;
      var clone = cloneElement(child, _extends({
        gridColumn: isTerm ? termWidth : detailWidth,
        gridColumnStart: !isTerm && lastIsDetail ? getDetailStart(1) : undefined,
        // Set a key as we've changed the heirachy and React gets confused
        key: i
      }, child.props));
      lastChild = child;
      return clone;
    });
    return clones;
  };

  return React__default.createElement("dl", _extends({
    ref: ref
  }, mapProps(props, rest, commonPropKeys, classNames)), renderChildren());
});

if (__DEV__) {
  DescriptionList.displayName = 'DescriptionList';
}

export default DescriptionList;
//# sourceMappingURL=index.esm.js.map
